<template>
<div class="customer-orders">
  <div
    v-for="count in counter"
    :key="count.label"
    class="customer-order-counter"
    >
    <b>{{count.quantity}} </b>
    <span>{{count.label}}</span>
  </div>

  <el-button secondary danger margin-top
    @click="openAddManualCustomer = true"
    >
    Add customer
  </el-button>

  <el-collapse-header title="Filters">
  <el-multi-switch margin-top
    :options="[{
      label: 'Sort by date',
      value: 'timestamp'
    }, {
      label: 'Sort by name',
      value: 'firstName'
    }]"
    v-model="sortByAttr"
    />

  <el-multi-switch margin-top
    :options="filterSalesChannels"
    v-model="filterSalesChannel"
    />
  </el-collapse-header>

  <el-multi-switch margin-top
    :options="filterOptions"
    v-model="filter"
    />
  <br>

  <!-- Orders -->
  <transition-group name="list-complete">
  <div
    v-for="order in filteredOrders"
    :key="order.id"
    @click="openId = order.id"
    class="customer-wrapper animation"
    >
    <el-inline :wrap="false" space-between>
      <h2 class="customer-name">{{order.firstName}} {{order.lastName}}</h2>

      <el-tag
        :warning="order.status === 0"
        :info="order.status === 1"
        :success="order.status === 2"
        :danger="order.status === 3"
        >
        {{getStatus(order.status)}}
      </el-tag>
    </el-inline>

    <el-inline :margin-top="false" stretch space-between>
      <span>
        {{order.purchase.total}} kr
        <b
          v-if="order.paymentMethod === 'klarna'"
          style="color: #F2A4AF; margin-left: 10px;"
          >
          Klarna
        </b>
      </span>
      <span>{{ (new Date(order.timestamp)).toDateString() }}</span>
    </el-inline>

    <el-delimiter short />
  </div>
  </transition-group>

  <!-- View purchase info -->
  <el-modal root
    v-if="openId !== null"
    @close="openId = null"
    close-button-align="right"
    >
    <el-inline space-between>
      <h2 style="margin-bottom: 0px;">{{activeOrder.firstName}} {{activeOrder.lastName}}</h2>
      <el-tag
        v-if="activeOrder.paymentMethod === 'klarna'"
        :info="true"
        >
        Klarna
      </el-tag>
    </el-inline>
    <p style="margin-top: 0px;">Name</p>

    <h2 style="margin-bottom: 0px;">{{activeOrder.address}}, {{activeOrder.postCode}}, {{activeOrder.city}}</h2>
    <p style="margin-top: 0px;">Address</p>

    <h2 style="margin-bottom: 0px;">{{activeOrder.email}}</h2>
    <p style="margin-top: 0px;">Email</p>

    <h2 style="margin-bottom: 0px;">{{activeOrder.phoneNumber}}</h2>
    <p style="margin-top: 0px;">Phone number</p>

    <h2 style="margin-bottom: 0px;">Purchase</h2>
    <i style="margin-top: 0px;">{{ (new Date(activeOrder.timestamp)).toDateString() }} at {{new Date(activeOrder.timestamp).toLocaleTimeString()}}</i>
    <el-message success
      v-if="activeOrder.couponCode !== ''">
      Code: <b>{{activeOrder.couponCode}}</b>
    </el-message>
    <el-message info
      v-if="typeof activeOrder.partnerCode === 'string' && activeOrder.partnerCode !== ''">
      Partner: <b>{{activeOrder.partnerCode}}</b>
    </el-message>
    <el-message>
      Sales channel: <b>{{$store.getters.salesChannel(activeOrder.salesChannel)}}</b>
    </el-message>

    <br>

    <el-inline
      v-for="(item, index) in activeOrder.purchase.items"
      :key="index"
      :margin-top="true"
      >
      <b style="width: 200px">{{item.name}}</b>{{item.price}} kr
    </el-inline>

    <el-inline :margin-top="true">
      <b style="width: 200px">Total: </b> <b>{{activeOrder.purchase.total}} kr</b>
    </el-inline>

    <el-delimiter />

    <h2 style="margin-bottom: 0px;">Status</h2>
    <el-dropdown
      :options="statusOptions"
      v-model="activeOrder.status"
      @change="setStatus"
      />

    <h2 style="margin-bottom: 0px;">Notes</h2>
    <textarea
      class="customer-note"
      v-model="activeOrder.note"
      @change="setNote"
      />
  </el-modal>

   <!-- Error modal -->
  <el-modal
    v-if="errorMessage !== ''"
    @close="errorMessage = ''"
    close-button-align="right"
    >
    <h1>Error!</h1>
    <p>{{errorMessage}}</p>
  </el-modal>

  <!-- Status -->
  <el-sticky-footer v-if="isLoading">
    <el-message :warning="true">
      <p>Loading coupons.</p>
    </el-message>
  </el-sticky-footer>
  <el-sticky-footer v-if="isPending">
    <el-message :info="true">
      <p>Syncronizing with the server.</p>
    </el-message>
  </el-sticky-footer>

  <!-- Manually add customer -->
  <el-modal root
    v-if="openAddManualCustomer === true"
    @close="openAddManualCustomer = false"
    close-button-align="right"
    >
    <el-header>Manually add a customer</el-header>

    <b>Contact</b>
    <el-inline nowrap space-between>
      <el-input margin-right
        v-model="manualCustomer.firstName"
        placeholder="First name"
        />
      <el-input
        v-model="manualCustomer.lastName"
        placeholder="Last name"
        />
    </el-inline>

    <el-inline nowrap space-between margin-top>
      <el-input margin-right
        v-model="manualCustomer.email"
        placeholder="Email"
        />
      <el-input
        v-model="manualCustomer.phoneNumber"
        placeholder="Phone number"
        />
    </el-inline>

    <br>
    <el-column margin-top>
      <el-column-item>
        <b>Coupon code</b>
        <el-input
          v-model="manualCustomer.couponCode"
          />
      </el-column-item>
      <el-column-item>
        <b>Partner code</b>
        <el-dropdown
          :options="partnerCodes"
          v-model="manualCustomer.partnerCode"
          />
      </el-column-item>
    </el-column>

    <br>
    <el-column margin-top>
      <el-column-item>
        <b>Date</b>
        <input type="date" name="bday" class="el-input"
          v-model="manualCustomer.timestampDate"
          placeholder="yyyy-mm-dd"
          >
        <i>{{new Date(manualCustomer.timestampDate).toDateString()}}</i>
      </el-column-item>
      <el-column-item>
        <b>Quantity</b>
        <input type="number" class="el-input"
          v-model="manualCustomer.quantity"
          >
      </el-column-item>
      <el-column-item>
        <b>Total (kr)</b>
        <input type="number" class="el-input"
          v-model="manualCustomer.total"
          >
      </el-column-item>
    </el-column>

    <br><br>
    <b>Sales channel</b>
    <el-dropdown
      :options="salesChannels"
      v-model="manualCustomer.salesChannel"
      />

    <br><br>
    <b>Delivery address</b>
    <el-input
      placeholder="Address"
      v-model="manualCustomer.address"
      />
    <el-input margin-top
      placeholder="City"
      v-model="manualCustomer.city"
      />
    <el-input margin-top
      placeholder="Post code"
      v-model="manualCustomer.postCode"
      />

    <br><br>
    <el-textarea margin-top
      v-model="manualCustomer.note"
      placeholder="Note"
      />

    <el-inline slot="footer">
      <el-button margin-right
        @click="addCustomer"
        >
        Add customer
      </el-button>
      <el-button danger secondary
        @click="clearManualInput"
        >
        Undo
      </el-button>
    </el-inline>
  </el-modal>
</div>
</template>
<script>

import dataLog from 'services/dataLog.js'
import firestore from 'services/firestore.js'
import emailApi from 'services/emailApi.js'
import logScope from 'log-scope'

const log = logScope('CustomerOrders')

export default {
  data () {
    return {
      filterOptions: [
        { value: -1, label: 'All' },
        { value: 0, label: 'New' },
        { value: 1, label: 'Sent' },
        { value: 2, label: 'Billed' },
        { value: 3, label: 'Returned' },
        { value: 4, label: 'Other' }
      ],
      filter: 0,
      filterSalesChannel: -1,
      sortByAttr: 'timestamp',
      isLoading: false,
      isPending: false,
      errorMessage: '',
      openId: null,
      openAddManualCustomer: false,
      manualCustomer: {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        couponCode: '',
        email: '',
        phoneNumber: '',
        postCode: '',
        salesChannel: 3,
        note: '',
        status: 0,
        quantity: 1,
        timestampDate: new Date().yyyymmdd(),
        total: 2995
      }
    }
  },
  computed: {
    counter () {
      const counter = {}
      this.statusOptions.forEach(({ value }) => {
        counter[value] = {
          label: this.getStatus(value),
          quantity: this.purchases.filter(p => p.status === value).length
        }
      })
      return counter
    },
    statusOptions () {
      return this.filterOptions.filter(o => o.value !== -1)
    },
    activeOrder () {
      const order = this.orders.find(order => order.id === this.openId)
      if (!order.note) {
        order.note = ''
      }
      return order
    },
    filteredOrders () {
      let orders = this.orders
        .filter(order => order.status === this.filter || this.filter === -1)
        .filter(order => order.salesChannel === this.filterSalesChannel || this.filterSalesChannel === -1)

      if (this.sortByAttr === 'timestamp') {
        return orders
      }

      return orders.sort((a, b) => a[this.sortByAttr].localeCompare(b[this.sortByAttr]))
    },
    purchases () {
      return this.$store.getters.purchases
    },
    orders () {
      return this.purchases.map(order => {
        let matchingTotal = true
        let id = order.id
        let status = order.status ? order.status : 0
        let purchase = {
          items: [],
          total: 0
        }

        for (let i = 0; i < order.quantity; i++) {
          purchase.items.push({
            name: 'HeadQ',
            price: order.price
          })

          purchase.total += order.price
        }

        if (order.total !== purchase.total) {
          log.error('WARNING! Unmatched total. ID: ' + id, order)
          matchingTotal = false
        }

        return {
          matchingTotal,
          ...order,
          id,
          status,
          purchase
        }
      })
        .filter(order => order.matchingTotal === true)
    },
    salesChannels () {
      return [{
        label: '-- Sales channel --',
        value: null
      }, ...this.$store.getters.salesChannels]
    },
    filterSalesChannels () {
      return [{
        label: 'All',
        value: -1
      }, ...this.$store.getters.salesChannels.map(s => ({
        label: s.label.substring(0, 11),
        value: s.value
      }))]
    },
    partnerCodes () {
      return [
        {
          label: '-- no partner code --',
          value: ''
        },
        ...this.$store.getters.partners
          .map(p => ({
            label: p.description,
            value: p.code
          }))
      ]
    }
  },
  methods: {
    getStatus (status) {
      return {
        0: 'New',
        1: 'Sent',
        2: 'Billed',
        3: 'Returned',
        4: 'Other'
      }[status]
    },
    getStatusCode (status) {
      return {
        'new': 0,
        'sent': 1,
        'billed': 2,
        'returned': 3,
        'other': 4
      }[status.toLowerCase()]
    },
    async setStatus (newStatus) {
      const status = Number(newStatus)
      const statusType = this.getStatus(status).toLowerCase()
      const id = this.openId
      const email = this.activeOrder.email
      const isSent = this.activeOrder.isSent === true
      const collection = this.activeOrder.collection || 'purchases'
      this.isPending = true

      log.debug('collection', collection)

      try {
        await firestore.set(collection, id, { status }, { merge: true })
        log.success('Updated purchase ID: ' + id)

        // Status = sent
        if (statusType === 'sent' && !isSent) {
          await this.addToUserEmailList(id, email, collection)
        }

        // Rejected
        if (statusType === 'returned') {
          await dataLog.adminLogLatest({
            status: 'warning',
            message: 'HeadQ returned'
          })
        }
      } catch (err) {
        log.error('Could not set purchase status', err)
        alert('Could not change status')
      }

      this.isPending = false
    },
    async setNote () {
      const note = this.activeOrder.note
      const collection = this.activeOrder.collection || 'purchases'

      const id = this.openId
      this.isPending = true

      try {
        await firestore.set(collection, id, { note }, { merge: true })
        log.success('Updated note in purchase ID: ' + id)
      } catch (err) {
        log.error('Could not set purchase note', err)
        alert('Could not change note')
      }

      this.isPending = false
    },
    async addToUserEmailList (id, email, collection) {
      log.debug('About to add to email list: ' + email)

      const res = await emailApi.newUser(email)
      log.success('Added to email list', res.data)

      await firestore.set(collection, id, {
        isSent: true
      }, { merge: true })
      log.success('Updated is sent ID: ' + id)

      // await dataLog.adminLogLatest({
      //   status: 'info',
      //   message: 'HeadQ delivered'
      // })
      log.success('Latest updated')
    },
    async addCustomer () {
      // Number attr
      ;['quantity', 'total', 'status', 'salesChannel'].forEach(type => {
        this.manualCustomer[type] = Number(this.manualCustomer[type])
      })

      const data = {
        ...this.manualCustomer,
        price: this.manualCustomer.total / this.manualCustomer.quantity,
        timestamp: +new Date(this.manualCustomer.timestampDate),
        collection: 'manualPurchases'
      }

      log.debug('Manually adding', { ...data })

      try {
        await firestore.add('manualPurchases', data)
        this.clearManualInput()
      } catch (err) {
        log.error('Could not add customer', err)
      }
    },
    clearManualInput () {
      this.manualCustomer = {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        couponCode: '',
        email: '',
        phoneNumber: '',
        postCode: '',
        note: '',
        status: 0,
        quantity: 1,
        salesChannel: 3,
        timestampDate: new Date().yyyymmdd(),
        total: 2995
      }

      this.openAddManualCustomer = false
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/elElement/variables.less';

  .customer-order-counter {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 15px;

    b {
      font-size: 24px;
    }

    span {
      font-size: 14px;
    }
  }

  .customer-note {
    width: 100%;
    min-height: 100px;
    resize: vertical;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px solid #cacaca;
    font-size: 14px;
    padding: 10px;
  }

  .customer-orders {

  }

  .customer-wrapper {
    cursor: pointer;
  }

  .customer-name {
    margin-bottom: 0px;
    margin-top: 0px;
    margin-right: 10px;

    @media (max-width: 600px) {
      font-size: 18px;
    }
  }

  .list-complete-item {
    transition: all 1s;
    display: inline-block;
    margin-right: 10px;
  }
  .list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .list-complete-leave-active {
    position: absolute;
  }
</style>
